// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { OrderTypeMap } from "../../../../Utils/Trading/OrderType.js"

// TODO. Refactor. App needs only 1 instance per order type.
// Rename. UGLY.

export let OrderTypeBase = function (orderEdit, modifyOrder)
{
    // TODO. Rename. Synonymic names.
    this.orderEdit = orderEdit
    this.modifyOrder = modifyOrder
}

// TODO. Refactor.
OrderTypeBase.prototype.localizationKey = function ()
{
    return OrderTypeMap[this.id()]
}

// TODO. Refactor.
OrderTypeBase.prototype.id = function ()
{
    return -1
}

// TODO. Refactor. CheckSession.
OrderTypeBase.prototype.IsSupported = function (params)
{
    return OrderTypeBase.IsSupported(this.id(), params.instrument, params.checkSession)
}

// TODO. Refactor.
OrderTypeBase.IsSupported = function (orderTypeId, instrument, checkSession)
{
    if (!instrument || instrument.isMultiInstrument || instrument.IsEmpty)
        return false

    checkSession =
        checkSession === undefined
            ? true
            : !!checkSession

    let route = instrument
        ? instrument.DataCache.getRouteByName(instrument.Route)
        : null

    return route &&
        route.IsAllowableOrderType(orderTypeId) &&
        (!checkSession || instrument.IsAllowOrderType(orderTypeId))
}

// TODO. Rename.
OrderTypeBase.prototype.createOrderEditObject = function (data)
{
    if (this.orderEdit)
        return new this.orderEdit(data)

    return null
}

// TODO. Refactor. Rename. UGLY.
OrderTypeBase.prototype.createModifyOrderObject = function (data)
{
    if (this.modifyOrder)
        return new this.modifyOrder(data)

    return null
}

OrderTypeBase.prototype.checkRuleForAccount = function (account, rule, instrument)
{
    let dc = account ? account.DataCache : (instrument ? instrument.DataCache : null);
    return dc.isAllowedForAccount(rule, account);
}

// #region Utils

// TODO. Refactor. Ugly.
OrderTypeBase.Parameters = function ()
{
    this.instrument = null
    this.account = null
    this.checkSession = true
    this.checkRuleForTrailingStopOrder = true
}

OrderTypeBase.Parameters.prototype.setInstrument = function (instrument)
{
    this.instrument = instrument
    return this
}

OrderTypeBase.Parameters.prototype.setAccount = function (account)
{
    this.account = account
    return this
}

OrderTypeBase.Parameters.prototype.setCheckSession = function (checkSession)
{
    this.checkSession = checkSession
    return this
}

// #endregion